import { css as _css } from "@emotion/core";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { makeMouseDragCallbacks } from '@domain-group/fe-allhomes-nuka-carousel';
import ThreeDIcon from '@domain-group/fe-co-icon/lib/js/three-dimensional';
import { MultiResolutionBackgroundDiv } from '@domain-group/fe-co-multi-resolution-image';
import * as models from '../../models';
import * as styles from './carousel-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SLIDE_DRAG_THRESHOLD = 50;
var VirtualTourCarouselItem = _ref => {
  var item = _ref.item,
    onClick = _ref.onClick,
    layout = _ref.layout,
    className = _ref.className;
  var isFallback = item.src && item.src.startsWith('http://');
  return ___EmotionJSX("div", _extends({
    className: className,
    key: item.src
  }, makeMouseDragCallbacks(SLIDE_DRAG_THRESHOLD), {
    onDragStartCapture: event => {
      event.preventDefault();
      event.stopPropagation();
    }
  }), isFallback ? ___EmotionJSX(MultiResolutionBackgroundDiv, {
    css: styles.image,
    src: item.srcHighDef,
    srcLowResolution: item.src
  }, ___EmotionJSX("a", {
    key: item.src,
    href: item.src,
    title: item.title,
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "3D"
  }, ___EmotionJSX("button", {
    type: "button",
    css: /*#__PURE__*/_css([styles.overlay, styles.asLink]),
    onClick: onClick,
    "aria-label": "3D"
  }, ___EmotionJSX(ThreeDIcon, {
    size: "custom",
    css: styles.overlayIcon
  })))) : ___EmotionJSX("div", {
    css: styles.interactive({
      layout
    })
  }, ___EmotionJSX("iframe", {
    title: "Virtual Tour",
    css: styles.virtualTourIFrame,
    src: item.src
  })));
};
VirtualTourCarouselItem.propTypes = {
  item: PropTypes.shape(models.item).isRequired,
  showOverlay: PropTypes.bool,
  onClick: PropTypes.func,
  layout: PropTypes.shape(models.layout),
  className: PropTypes.string
};
VirtualTourCarouselItem.defaultProps = {
  showOverlay: false,
  onClick: () => {},
  layout: {},
  className: ''
};
export default VirtualTourCarouselItem;